import React, { Component } from 'react'
import style from './style.css'

class Button extends Component {
    
    render() {
        return (
            <button
                type={this.props.type || 'submit'}
                className={`${style.btn} ${style[`${this.props.theme}`]} ${this.props.styled ? style[`styled-${this.props.styled}`] : ''} ${this.props.inline ? style.inline : ''} ${this.props.disabled ? style.disabled : ''} ${this.props.xs ? style.xs : ''}`}
                onClick={this.props.onClick || null}
                disabled={this.props.disabled || false}
                style={{
                    ...this.props.style,
                }}
            >
                {this.props.children || this.props.label || ''}
            </button>
        )
    }
}

export default Button


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/Button/index.js